<div class="form-group">
  <label [hidden]="hideLabel" for="SelectedObject">{{ labelText }}</label>
  <ng-select required [items]="daysOptions" bindValue="Value" [multiple]="false" [hideSelected]="true"
             [loading]="selectionListLoading" [typeahead]="selectionListInput$" [(ngModel)]="selectedObjectId"
             name="SelectedObject" placeholder="{{selectObjectText}}" (change)=selectedObjectChanged($event)>
    <!-- Template for dropdown items -->
    <ng-template ng-option-tmp let-item="item" let-index="index">
      {{ item.Label | translate:{Number: item.Value} }}
    </ng-template>

    <!-- Template for selected item label -->
    <ng-template ng-label-tmp let-item="item">
      {{ item.Label | translate:{Number: item.Value} }}
    </ng-template>
  </ng-select>
</div>
